<template>
    <div class="dropdown"
         :class="[checkSize() ? 'pull-right' : 'pull-left clear-both']"
         id="advanced_filters">
        <div class="pull-right no-select">
            <button class="btn white dropdown-toggle py-1 px-3"
                    data-toggle="dropdown"
                    data-flip="false"
                    :disabled="loading">
                <i class="fa fa-filter"></i>
            </button>

            <div class="dropdown-menu dropdown-menu-right mega-dropdown-menu dropdown-menu-overlay lean-bottom-margin bold-label right-align no-select"
                 v-on:click="noClose($event)">
                <div class="row nav-padding">
                    <div class="col-12">
                        <div class="dropdown-divider"></div>
                        <el-form label-position="left">
                            <el-form-item label="Status">
                                <el-select class="filter-select pull-right"
                                           v-model="filter[filter_name].status"
                                   placeholder="All"
                                           @change="changeStatus"
                                           style="max-width: 250px">
                                    <el-option
                                        v-for="item in statuses"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                            <span>
                                                {{ item.label }}
                                            </span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="Hide Sub Users"
                                          v-if="filter_name === 'user'">
                                <el-switch
                                    v-model="filter[filter_name].hide_sub_users"
                                    class="pull-right"
                                    active-color="#00a344"
                                    :active-value="true"
                                    :inactive-value="false"
                                    @change="handleHideSubUsers">
                                </el-switch>
                            </el-form-item>
                            <el-form-item label="Hide cancelled subscriptions">
                                <el-switch
                                        v-model="filter[filter_name].show_cancelled"
                                        class="pull-right"
                                        active-color="#00a344"
                                        :active-value="false"
                                        :inactive-value="true"
                                        @change="handleHideCancelledSubscription">
                                </el-switch>
                            </el-form-item>
                            <el-form-item label="Plans">
                                <el-select class="filter-select pull-right"
                                           v-model="filter[filter_name].plan_id"
                                           placeholder="All"
                                           @change="changePlan"
                                           style="max-width: 250px">
                                    <el-option :value="null">All</el-option>
                                    <el-option
                                            v-for="item in plans"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                            <span>
                                                {{ item.name }}
                                            </span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="Rates">
                                <el-select class="filter-select pull-right"
                                           v-model="filter[filter_name].rate_id"
                                           placeholder="All"
                                           @change="changeRate"
                                           style="max-width: 250px">
                                    <el-option :value="null">All</el-option>
                                    <el-option
                                            v-for="item in rates"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                            <span>
                                                {{ item.name }}
                                            </span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="col-12 mt-2">
                        <button class="btn blackish btn-block p-x-md"
                                @click="resetOurFilters">
                            Reset Filters
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import auth from '../auth'
    import {mapActions, mapGetters, mapState} from 'vuex'

    export default {

        props: ['filter_name'],

        computed: {
            ...mapGetters({
                filter: 'getFilter',
            }),

            ...mapState({
                filters: state => state.filters,
                plans: state => state.plans,
                rates: state => state.rates
            }),
        },

        data() {
            return {
                auth: auth,
                loading: false,
                statuses: [
                    {
                        value: 'active',
                        label: 'Enabled'
                    },
                    {
                        value: 'inactive',
                        label: 'Disabled'
                    },
                    {
                        value: 'all',
                        label: 'All'
                    }
                ]
            }
        },

        mounted() {
            this.resetOurFilters()
        },

        methods: {
            noClose(event) {
                if (event) {
                    event.stopPropagation()
                }
            },

            changeStatus(status) {
                this.filter[this.filter_name].status = status
            },

            changePlan(plan_id) {
                this.filter[this.filter_name].plan_id = plan_id
            },

            changeRate(rate_id) {
                this.filter[this.filter_name].rate_id = rate_id
            },

            handleHideSubUsers(hide_sub_users) {
                this.filter[this.filter_name].hide_sub_users = hide_sub_users
            },

            handleHideCancelledSubscription(show_cancelled) {
                this.filter[this.filter_name].show_cancelled = show_cancelled
            },

            checkSize() {
                let valid_sizes = ['xxl', 'xl']
                if (valid_sizes.includes(this.$mq)) {
                    return true
                }
                return false
            },

            resetOurFilters() {
                this.resetFilters(this.filter_name)
            },

            ...mapActions(['resetFilters'])
        }
    }
</script>
